import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityEducation = () => {
  return (
    <div className="space-y-4">
      <div className="bg-primary/5 border border-primary/20 rounded-lg p-6">
        <div className="flex items-start gap-3 mb-4">
          <Icon name="Shield" size={24} className="text-primary flex-shrink-0" />
          <div>
            <h2 className="text-lg font-bold text-foreground mb-2">Why Enable Two-Factor Authentication?</h2>
            <p className="text-sm text-muted-foreground">
              Two-factor authentication (2FA) adds an extra layer of security to your account by requiring both your password and a verification code to sign in.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-card rounded-lg p-4">
            <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center mb-3">
              <Icon name="Lock" size={20} className="text-success" />
            </div>
            <h3 className="font-semibold text-foreground mb-1">Enhanced Security</h3>
            <p className="text-xs text-muted-foreground">
              Protects your health data even if your password is compromised
            </p>
          </div>

          <div className="bg-card rounded-lg p-4">
            <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center mb-3">
              <Icon name="UserCheck" size={20} className="text-success" />
            </div>
            <h3 className="font-semibold text-foreground mb-1">Verify It's You</h3>
            <p className="text-xs text-muted-foreground">
              Ensures only you can access your account, not unauthorized users
            </p>
          </div>

          <div className="bg-card rounded-lg p-4">
            <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center mb-3">
              <Icon name="Bell" size={20} className="text-success" />
            </div>
            <h3 className="font-semibold text-foreground mb-1">Login Alerts</h3>
            <p className="text-xs text-muted-foreground">
              Get notified of any suspicious login attempts on your account
            </p>
          </div>
        </div>
      </div>

      {/* Best Practices */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="Lightbulb" size={18} className="text-primary" />
          Best Practices
        </h3>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li className="flex items-start gap-2">
            <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
            <span>Save your backup codes in a secure location immediately</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
            <span>Use an authenticator app instead of SMS when possible</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
            <span>Keep your authentication device secure and up to date</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
            <span>Never share your verification codes with anyone</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SecurityEducation;